import { ReportHandler } from 'web-vitals';
import logger from './utils/logger';

const reportWebVitals = (onPerfEntry?: ReportHandler) => {
  logger.debug('reportWebVitals', 'Initializing web vitals reporting', { hasHandler: !!onPerfEntry });
  
  if (onPerfEntry && onPerfEntry instanceof Function) {
    logger.info('reportWebVitals', 'Loading web-vitals module');
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      logger.debug('reportWebVitals', 'Web-vitals module loaded, setting up metrics');
      
      const wrappedHandler = (metric: any) => {
        logger.debug('reportWebVitals', 'Web vital metric reported', { 
          name: metric.name, 
          value: metric.value, 
          rating: metric.rating 
        });
        onPerfEntry(metric);
      };
      
      getCLS(wrappedHandler);
      getFID(wrappedHandler);
      getFCP(wrappedHandler);
      getLCP(wrappedHandler);
      getTTFB(wrappedHandler);
      
      logger.info('reportWebVitals', 'Web vitals metrics initialized');
    }).catch((error) => {
      logger.error('reportWebVitals', 'Failed to load web-vitals module', error);
    });
  } else {
    logger.debug('reportWebVitals', 'No handler provided, skipping web vitals setup');
  }
};

export default reportWebVitals;
